import axios from "axios";
import config from '../../config'

// const credential = new StorageSharedKeyCredential(accountName, accountKey);

async function imageUpload(ImageList, object, propertyId, accountId, altTexts) {
  //send propertyId and object in the body
  const { data } = await axios.post(`${config.API_URL}/v2/image/create-upload-request`,
    { propertyId, object },        // <-- request body
    {headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}}      // <-- config
  );

  const { uploadUrl, blobName } = data;

  const imageNames = [];
  const imageSchemaDatas = [];
  let counter = 0;
  for (const image of ImageList) {
    //get image name
    const imageName = image.name;
    const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
    let finalName = blobName + `${object}-${accountId}-${timestamp}-${imageName.replace(/\s+/g, "-")}`;
    if (imageNames.includes(finalName)) {
      finalName = finalName.replace(/\.[^/.]+$/, "") + `-${counter}` + imageName.substring(imageName.lastIndexOf('.'));
    }
    imageNames.push(finalName);
    //split the link by ?
    const [baseUrl, SASKEY] = uploadUrl.split("?");
    const finalImageLink = `${baseUrl}/${finalName}?${SASKEY}`;
    try {
      await axios.put(finalImageLink, image.data, {
        headers: {
          'x-ms-blob-type': 'BlockBlob',
          'Content-Type': image.type
        }
      });
    } catch (error) {
      console.error("Error uploading image:", error);
    }

    imageSchemaDatas.push({
      name: `${baseUrl}/${finalName}`,
      altText: altTexts[counter]
    });
    counter++;
  }

  const imageSchemaIds = await axios.post(`${config.API_URL}/v2/image/attach-uploads-to-schema`, {
    imageSchemaDatas
  }, {headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}});

  return imageSchemaIds.data;

}

// async function getUniqueBlobName(containerClient, originalName) {
//   let nameWithoutExt = originalName;
//   let extension = "";

//   // Split name into base + extension if there's a dot
//   const dotIndex = originalName.lastIndexOf(".");
//   if (dotIndex !== -1) {
//     nameWithoutExt = originalName.substring(0, dotIndex);
//     extension = originalName.substring(dotIndex);
//   }

//   let counter = 1;
//   let blobName = originalName;
//   let blockBlobClient = containerClient.getBlockBlobClient(blobName);

//   while (await blockBlobClient.exists()) {
//     counter++;
//     blobName = `${nameWithoutExt}-${counter}${extension}`;
//     blockBlobClient = containerClient.getBlockBlobClient(blobName);
//   }

//   return blobName;
// }

/* function getFormattedDate() {
  const date = new Date();
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // months are 0-indexed
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
} */

export default imageUpload;